import { useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const nonOrganizationPathSegments = new Set(['admin', 'admin-trace', 'organizations', 'welcome']);

const normalizePath = (path) => {
  if (!path || path === '/') {
    return '';
  }
  return path.startsWith('/') ? path : `/${path}`;
};

export const getOrganizationPath = (organizationId, path) => {
  const normalizedPath = normalizePath(path);
  if (!organizationId) {
    return normalizedPath || '/';
  }

  const encodedOrganizationId = encodeURIComponent(organizationId);
  const organizationRoot = `/${encodedOrganizationId}`;
  if (normalizedPath === organizationRoot || normalizedPath.startsWith(`${organizationRoot}/`)) {
    return normalizedPath;
  }
  return `${organizationRoot}${normalizedPath}`;
};

export const getOrganizationIdFromPath = (pathname) => {
  const segment = String(pathname || '')
    .split('/')
    .filter(Boolean)[0];
  if (!segment || nonOrganizationPathSegments.has(segment)) {
    return undefined;
  }
  return decodeURIComponent(segment);
};

export const useOrganizationPath = () => {
  const { organizationId: paramsOrganizationId } = useParams();
  const location = useLocation();
  const organizationId = paramsOrganizationId || getOrganizationIdFromPath(location.pathname);
  const resolveOrganizationPath = useCallback(
    (path) => getOrganizationPath(organizationId, path),
    [organizationId],
  );

  return {
    organizationId,
    resolveOrganizationPath,
  };
};
